module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"compareText":"We compare premiums from Ireland’s leading {0} providers"}}')
  delete Component.options._Ctor
}
